// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2jlTl","inner":"Form_inner__PJZKw","range":"Form_range__2J2m3","name":"Form_name__2jBAD","actions":"Form_actions__35SCp"};